module.exports = "body {\n  overflow-x: scroll; }\n"